module.exports = __webpack_public_path__ + "static/media/fire2.91dcbb7b.svg";